import { createGlobalStyle } from "styled-components";
import { fontFaces } from "./fontFaces";
import 'react-phone-number-input/style.css';
const GlobalStyle = createGlobalStyle`

${fontFaces
  .map((face) => {
    return `
    @font-face {
      font-family: '${face.family}';
      ${face.weights
        .map(
          (weight) =>
            `src: ${weight.src} format('${weight.format}') ${weight.weight};`
        )
        .join("\n      ")}
      font-style: ${face.options.style};
      font-display: ${face.options.display};
    }
    ${face.weights.map(
      (weight) => `
        .${face.family}-${weight.weight} {
          font-family: '${face.family}';
          font-weight: ${weight.weight};
        }
      `
    )}
  `;
  })
  .join("\n")}

* {
        margin: 0;
        padding: 0;
        box-sizing: border-box;
        font-family: 'SF Pro Display', sans-serif;
        -webkit-tap-highlight-color: rgba(0,0,0,0);
        -webkit-tap-highlight-color: transparent;
        -webkit-text-size-adjust: none;
        
        &::-webkit-scrollbar {
            width: 0;
        }
  }

  html {
    height: 100%;
  }
  
  body {
        width: 100%;
        height: 100%;
    
        > * {
          width: 100%;
          height: 100%; 
        }
    }
    
  input[type="text"],
  input[type="tel"],
  input[type="email"],
  input[type="password"],
  input[type="tel"],
  input[type="textarea"],
  input[type="radio"],
  textarea,
  input {
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
  }
  
  input[type="radio"] {
      display: none;
  }
  
  a, input, button {
    font-family: 'SF Pro Display', sans-serif;
  }

  //Gooogle Map Global Styles

  .gm-style .gm-style-iw-c {
    padding: 0;
    background-color: transparent;
    box-shadow: none;
    border-radius: 22px;
    transform: translate(-50%,-165%);
    max-width: unset !important;
    max-height: unset !important;
    top: 90px;


    &:focus {
      outline: none !important;
    }

  }

  .gm-style .gm-style-iw-tc {
    display: none;
  }

  .gm-style-iw-d {
    overflow: hidden !important;
    max-width: unset !important;
    max-height: unset !important;
  }

  .gm-ui-hover-effect {
    display: none !important;
  }

  .gm-style-iw-t::after {
    width: 0 !important;
  }


  .gmnoprint.gm-bundled-control.gm-bundled-control-on-bottom,
  .gmnoprint.gm-bundled-control {
    div {
      background-color: transparent !important;
      border: none !important;
      box-shadow: none !important;
    }

    .gm-control-active {
      background-color: #fff !important;
      border-radius: 50% !important;
      margin-bottom: 15px !important;
    }
  }

  .gmnoprint {
    z-index: 2000 !important;
  }

  //Overriding phone input styles

  .PhoneInput {
    width: 100%;
  }

  .PhoneInputInput:focus {
    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #3393EC;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }    
  }

  .PhoneInputInput {
    width: 100%;
    height: 56px;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    letter-spacing: -0.41px;
    color: #323232;
    border: none;
    border-radius: 0;
    border-bottom: 1px solid transparent;
    border-top: 1px solid transparent;
    border-left: 1px solid transparent;
    border-right: 1px solid transparent;
    margin-top: 10px;
    padding: 14px 16px 14px 60px;
    border-radius: 12px;
    background: #F6F6F6;
    &:focus,
    &:visited,
    &:active {
      outline: none;
      border: 1px solid #3393EC;
      border-radius: 12px;
      -webkit-border-radius: 12px;
      -moz-border-radius: 12px;
      -ms-border-radius: 12px;
    }  

    &::placeholder {
      color: #848484;
      font-weight: 300;
    }
  }

  .PhoneInputCountry {
    position: absolute;
    top: 26px;
    left: 12px;
  }

  .PhoneInputCountryIcon {
    width: 28px;
    height: 22px;
  }

  .PhoneInputCountryIcon--border {
    background-color: transparent;
    border: none;
    box-shadow: none;
  }

`;

export default GlobalStyle;
